import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Directive,
    ElementRef,
    Input,
    OnInit,
    Renderer
} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../../autenticacion/servicios/auth.service';
import {ConsumerService} from '../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../recursos/modelo/consumerModel/web-services.enum';
import {UtilConfig} from '../../../../autenticacion/servicios/UtilConfig';
import {Router} from '@angular/router';
import * as moment from 'moment';
import {BillingConfiguration} from '../../seguridad/emisor/recursos/modelo/emisor-configuration';
import {TipoDocumento} from '../../seguridad/emisor/recursos/modelo/tipo-documento.enum';
import {Observable} from '../../../../../../node_modules/rxjs/Observable';
import {debounceTime, map, startWith} from '../../../../../../node_modules/rxjs/operators';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {StockProducts} from '../../seguridad/emisor/recursos/modelo/stockProducts';
import {MatSnackBar} from '@angular/material';
import {Receiver} from '../../seguridad/emisor/recursos/modelo/Receiver';
import {MeasurementUnits} from '../../seguridad/emisor/recursos/modelo/MeasurementUnits';
import {Ide} from 'app/layout/content/emisorFacturas/recursos/modelo/ide';
import {Emi} from 'app/layout/content/emisorFacturas/recursos/modelo/Emi';
import {Rec} from 'app/layout/content/emisorFacturas/recursos/modelo/Rec';
import {Item} from '../recursos/modelo/item';
import {Impuesto} from '../recursos/modelo/impuesto';
import {Cab} from 'app/layout/content/emisorFacturas/recursos/modelo/cab';
import {Option} from '../recursos/modelo/option';
import {CargoDescuento} from 'app/layout/content/emisorFacturas/recursos/modelo/cargoDescuento';
import {MatChipInputEvent} from "@angular/material/chips";
import {COMMA, ENTER} from "@angular/cdk/keycodes";

import {LogEmisor} from "../../transaccion/logEmisorTmp/recursos/modelo/LogEmisor";
import {Drf} from "../recursos/modelo/drf";
import { getDocumentInfo } from '../util/util-type-name';

declare var $: any;
declare var swal: any;

// tslint:disable-next-line:directive-selector
@Directive({selector: '[myFocusBoleta]'})
// tslint:disable-next-line:directive-class-suffix
export class FocusDirectiveBoleta implements OnInit {

    // tslint:disable-next-line:no-input-rename
    @Input('myFocusBoleta') isFocused: boolean;

    constructor(private hostElement: ElementRef, private renderer: Renderer) {
    }

    ngOnInit() {
        if (this.isFocused) {
            this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'focus');
        }
    }
}

@Component({
    selector: 'app-boleta',
    templateUrl: './view/boleta.component.html',
    styleUrls: ['./css/boleta.component.scss'],
    providers: [AuthService, ConsumerService],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoletaComponent implements OnInit {

    /**
     * PARAMETROS DE CONFIGURACION GENERAL
     *
     */
    DETRACCION = 10;
    RETENCION = 42;
    EXPORTACION_BIEN = 4;
    EXPORTACION_SERVICIO = 6;
    TIPO_OPERACION_VENTA_INTERNA = 46;

    IGV = 18.0;
    RUC = '6';
    DND = '0';
    DNI = '1';
    CARNET_EXTRAJERIA = '4';
    PASAPORTE = '7';

    // CATALOGOS
    CATALOGE_ACTIVE = '1';
    CAtALOGO_51 = '51';
    CAtALOGO_54 = '54';
    CAtALOGO_59 = '59';

    /**
     * PARAMETROS DE CARGA = LOADING
     *
     */
    loadingConsultas = [
        {
            modulo: 'Cargando Series',
            cargando: true
        },
        {
            modulo: 'Cargando Clientes',
            cargando: false
        },
        {
            modulo: 'Cargando Productos',
            cargando: false
        }
    ];
    loading_documento = false;
    loading_popup = false;


    mensaje = '';
    error = false;

    rucTmp = '';
    /**
     * FORMULARIOS Y VALIDADORES
     *
     */
    formBoleta: FormGroup;
    formReceptor: FormGroup;
    formAdditionalPermanent: FormGroup;
    formAdditionalTemp: FormGroup;
    formChangeAmountOrDate: FormGroup;
    formReceptorNuevo: FormGroup;
    formProductoNuevo: FormGroup;
    vld_changeMonto: FormControl;
    vld_changeDate: FormControl;
    vld_serie: FormControl;
    vld_servicioDetraccion: FormControl;
    vld_formaPago: FormControl;
    vld_rucReceptor: FormControl;
    vld_moneda: FormControl;
    vld_aux_telefono: FormControl;
    vld_aux_correo: FormControl;
    vld_aux_razonSocial: FormControl;
    vld_aux_direccion: FormControl;
    vld_fecha_vencimiento: FormControl;
    vld_item: FormControl;
    vld_tasaReten: FormControl;
    vld_tasaDetrac: FormControl;
    vld_cuenta: FormControl;
    vld_medPago: FormControl;
    vld_tipoCamb: FormControl;
    vld_cuotas: FormControl;
    vld_otrasDeducciones: FormControl;
    vld_montoPagado: FormControl;

    // RECEPTOR NUEVO
    vld_tipoReceptorNuevo: FormControl;
    vld_rucReceptorNuevo: FormControl;
    vld_TelefonoReceptorNuevo: FormControl;
    vld_CorreoReceptorNuevo: FormControl;
    vld_NameReceptorNuevo: FormControl;
    vld_DireccionReceptorNuevo: FormControl;

    // PRODUCTO NUEVO
    vld_codigoProductoNuevo: FormControl;
    vld_descripcionProductoNuevo: FormControl;
    vld_valorProductoNuevo: FormControl;
    // RECARGO AL CONSUMO
    vld_recargoConsumoPorcentaje: FormControl;
    vld_descuentoGlobalPorcentaje: FormControl;

    serieControl = new FormControl();
    rucControl = new FormControl();
    itemControl = new FormControl();
    aux_correo = '';
    aux_direccion = '';
    aux_razonSocial = '';
    aux_item = '';
    aux_telefono = '';

    /**
     * VARIABLES DE CONTROL DE VISUALIZACION
     *
     */
    editarReceptor = false;
    bsConfig: Partial<BsDatepickerConfig>;
    bsConfigCuota: Partial<BsDatepickerConfig>;
    colorTheme = 'theme-dark-blue';
    agregarShowItem = false;
    agregarShowReceptor = false;
    popupReceptor = false;
    popupProducto = false;

    /**
     * VARIABLES DE DATA
     *
     */
    items: FormArray;
    options: String[] = [];
    monedaType: any[] = [];
    operationType: any[] = [];
    impuestos: any[] = [];
    tipoDoc = '03';
    usuarioSession: any;
    servicioDetraccionList: any[] = [];
    catalogues: any[] = [];
    formaPago: any[] = ['Contado',
        'Credito',
        'Crédito a 7 días',
        'Crédito a 15 días',
        'Crédito a 30 días ',
        'Crédito a 60 días',
        'Crédito a 90 días'];
    receivers: Receiver[] = [];
    optionsRuc: Receiver[] = [];
    optionsItem: StockProducts[] = [];
    filteredOptionsSerie: Observable<String[]>;
    filteredServicioDetraccion: Observable<any[]>;
    filteredOptionsRuc: Observable<Receiver[]>;
    filteredOptionsItem: Observable<StockProducts[]>;
    servicioDetraccion: string;
    measurementUnits: MeasurementUnits[];
    popup_text = '';
    docType: any[] = [];
    tamanoIdDocNumber = 8;
    receptorNuevo: Receiver = new Receiver();
    productoNuevo: StockProducts = new StockProducts();
    poseeCargoDescuento = false;
    poseeDescuentoPorcentaje = true;
    descuentoGlobal: number = 0.00;
    poseeDescuentoGlobalDiv: boolean = true;
    poseeDescuentoGlobal: boolean = false;

    recargoConsumoPorcentaje = 0;
    tasaDetraccion = '';
    tasaRetencion = '3';
    nroCuotas = 1;
    tipoCambio: string;
    medioPago = '';
    medioPagoList: any[];
    nroCuenta: string;
    otrasDeduccion = '0.0';
    montoPagado = '0.0';
    changeDate: any;
    changeAmountPay: string;
    cuotaSelected: number = null;
    minDate: any;
    maxDate: any;

    /**
     *  TEMPLATE JSON BOLETA
     */
    template_boleta = this.nuevaBoleta();
    typeDocument: any = {value: this.DNI, label: 'DNI'};
    disabledTypeDocument = false;

    // Datos adicionales
    vld_notesOnTheReceipt: FormControl;
    vld_purchaseOrder: FormControl;

    vld_additionalTempKey: FormControl;
    vld_additionalTempValue: FormControl;
    vld_additionalPermanentKey: FormControl;
    vld_additionalPermanentValue: FormControl;

    keyTemp = '';
    valueTemp = '';
    keyPermanent = '';
    valuePermanent = '';
    // DATOS ADICIONALES
    notesOnTheReceipt: string = '';
    additionalDataPermanent = [];
    additionalDataTmp = [];
    guiaRemision = [];
    guiaRemisionTransporte = [];
    selectable = true;
    removable = true;
    addOnBlur = true;
    separatorKeysCodes = [ENTER, COMMA];
    loadingAddDataAditional = false;
    removeAdditionalPermanent = false;
    preview = false;
    print = false;
    totalLetter = '';
    step = 0;

    showCreationSummary = false;
    messageCreation = '';
    logSeleccionado = new LogEmisor();
    cargaDocumentos = false;

    amountWithIGV = false;

    constructor(private util: UtilConfig,
                private cd: ChangeDetectorRef,
                private fb: FormBuilder,
                private router: Router,
                private consumerService: ConsumerService,
                private snackBar: MatSnackBar) {
        this.usuarioSession = this.util.getCurrentUser();
        this.IGV = this.usuarioSession.customer.igv || 18.0;
        this.amountWithIGV = this.usuarioSession.customer.amountWithIGV || false;
        this.nroCuenta = this.usuarioSession.customer.cuentaBanco;
        this.createFormControls();
        this.createFormBoleta();
        this.changeAmountOrDate();
        this.createFormReceptor();
        this.createFormReceptorNuevo();
        this.createFormProductoNuevo();
        this.bsConfig = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD',
            minDate: moment().subtract(5, 'd').toDate(),
            maxDate: moment().add(2, 'd').toDate()
        });
        this.bsConfigCuota = Object.assign({}, {
            containerClass: this.colorTheme,
            showWeekNumbers: false,
            dateInputFormat: 'YYYY-MM-DD'
        });
        this.monedaType = [];
        this.monedaType.push({description: 'DOLARES', code: 'USD'});
        this.monedaType.push({description: 'EUROS', code: 'EUR'});
        this.monedaType.push({description: 'LIBRAS ESTERLINAS', code: 'GBP'});
        this.monedaType.push({description: 'SOLES', code: 'PEN'});

        this.optionsRuc = [];

        this.docType.push({value: this.DNI, label: 'DNI'});
        this.docType.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
        this.docType.push({value: this.PASAPORTE, label: 'Pasaporte'});
        this.docType.push({value: this.RUC, label: 'RUC'});
        this.docType.push({value: this.DND, label: 'DND'});

        this.impuestos = [];
        this.impuestos.push('GRAVADO');
        this.impuestos.push('INAFECTO');
        this.impuestos.push('EXONERADO');

        this.productoNuevo.affectationIGV = 'GRAVADO';

        const unit = new MeasurementUnits();
        unit.code = 'NIU';
        unit.description = 'number of international units';
        unit.label = 'Unidades';

        this.productoNuevo.measurementUnit = unit;

    }

    setStep(index: number) {
        this.step = index;
    }

    asignarRecargoConsumo(valor) {
        if (valor === 'SI') {
            this.poseeCargoDescuento = true;
            this.template_boleta.boleta.cab.cargoDescuento = [];
            this.template_boleta.boleta.cab.sumOtrosCargos = 0;
            this.recargoConsumoPorcentaje = 0;
        } else {
            this.recargoConsumoPorcentaje = 0;
            this.poseeCargoDescuento = false;
            this.template_boleta.boleta.cab.cargoDescuento = null;
            this.template_boleta.boleta.cab.sumOtrosCargos = null;
        }
    }

    ngOnInit(): void {
        this.getSeries();
        this.getCatalogos();
        this.getAdditionalDataPermanent();
        this.getUnit();
        this.getMonedas();
        this.getReceptores();
        this.getItems();
        this.changeFormaPago();
        this.template_boleta.boleta.det = [];
        this.filteredOptionsSerie = this.serieControl.valueChanges
            .pipe(
                startWith(''), debounceTime(500),
                map(value => {
                    return (value) ? this._filter(value) : this.options.slice();
                }));

        this.filteredServicioDetraccion = this.vld_servicioDetraccion.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterServicioDetraccion(value) : this.servicioDetraccionList.slice();
            }));

        this.filteredOptionsRuc = this.rucControl.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                this.rucTmp = value;
                return (value) ? this._filterRuc(value) : this.optionsRuc.slice();
            }));

        this.filteredOptionsItem = this.itemControl.valueChanges
            .pipe(startWith(''), debounceTime(500), map(value => {
                return (value) ? this._filterItem(value) : this.optionsItem.slice();
            }));
    }

    cargarTypeDocuments(docType: any) {
        this.typeDocument = docType;
        this.filterReceptores();
        this.template_boleta.boleta.rec.numeroDocId = '';
    }


    getMonedas() {
        this.consumerService.post<any>(WebServices.URL_GET_MONEDAS)
            .subscribe(result => {
                const monedas: any = result['currencyCodes'];
                if (monedas != null && monedas.length > 0) {
                    this.monedaType = [];
                    $.each(monedas, (pos, item) => {
                        this.monedaType.push({description: item.description, code: item.code});
                    });
                }
            }, err => {
                console.log('no se cargaron las monedas');
            });

    }

    getItems() {
        this.loadingConsultas[2].cargando = true;
        if (this.util.getProductList() != null) {
            this.optionsItem = [];
            $.each(JSON.parse(this.util.getProductList()), (pos, item) => {
                this.optionsItem.push(item);
            });
            this.loadingConsultas[2].cargando = false;
        }
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumerService.post<any>(WebServices.URL_GET_ITEMS, body)
            .subscribe(result => {
                const productos: any = result['productsStocks'];
                this.util.setProductList(productos);
                if (productos != null && productos.length > 0) {
                    this.optionsItem = [];
                    $.each(productos, (pos, item) => {
                        this.optionsItem.push(item);
                    });
                }
                this.loadingConsultas[2].cargando = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[2].cargando = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
                console.log('no se cargaron las productos');
            });

    }

    getReceptores() {
        this.optionsRuc = [];
        this.loadingConsultas[1].cargando = true;
        this.consumerService.search<any>('', 'ACTIVO', WebServices.URL_GET_RECEPTORES)
            .subscribe(result => {
                this.loadingConsultas[1].cargando = false;
                if (result['codigo'] === 1) {
                    this.receivers = result['receivers'];
                    this.filterReceptores();
                }
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.loadingConsultas[1].cargando = false;
                console.log('no se cargaron los receptores');
                this.cd.markForCheck();
                this.cd.detectChanges();
            });

    }


    private filterReceptores() {
        if (this.receivers != null && this.receivers.length > 0) {
            this.optionsRuc = [];
            $.each(this.receivers, (pos, item) => {

                if (item.idDocType === this.typeDocument.value) {
                    const receptor = new Receiver();
                    receptor.idDocType = item.idDocType;
                    receptor.idDocNumber = item.idDocNumber;
                    receptor.businessName = item.businessName;
                    receptor.phone = item.phone;
                    receptor.email = item.email;
                    receptor.address = item.address;
                    this.optionsRuc.push(receptor);
                }
            });
        }
    }

    createFormControls() {
        this.serieControl = new FormControl({value: ''}, [Validators.required]);
        this.vld_serie = new FormControl({value: ''}, [Validators.required]);
        this.vld_servicioDetraccion = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_formaPago = new FormControl({value: 'Contado'}, [Validators.required]);
        this.vld_rucReceptor = new FormControl({value: ''}, [Validators.required]);
        this.vld_moneda = new FormControl({}, [Validators.required]);
        this.vld_fecha_vencimiento = new FormControl({}, [Validators.nullValidator]);
        this.vld_item = new FormControl({}, [Validators.nullValidator]);
        this.vld_tasaDetrac = new FormControl({}, [Validators.nullValidator]);
        this.vld_tasaReten = new FormControl({}, [Validators.nullValidator]);
        this.vld_cuenta = new FormControl({}, [Validators.nullValidator]);
        this.vld_medPago = new FormControl({}, [Validators.nullValidator]);
        this.vld_tipoCamb = new FormControl({}, [Validators.nullValidator]);
        this.vld_cuotas = new FormControl({}, [Validators.nullValidator]);
        this.vld_otrasDeducciones = new FormControl({}, [Validators.nullValidator]);
        this.vld_montoPagado = new FormControl({}, [Validators.nullValidator]);

        this.vld_aux_correo = new FormControl({}, [Validators.required]);
        this.vld_aux_direccion = new FormControl({}, [Validators.required]);
        this.vld_aux_telefono = new FormControl({}, [Validators.required]);
        this.vld_aux_razonSocial = new FormControl({}, [Validators.required]);

        this.vld_changeDate = new FormControl({}, [Validators.required]);
        this.vld_changeMonto = new FormControl({}, [Validators.required]);

        this.vld_tipoReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_rucReceptorNuevo = new FormControl({value: ''}, [Validators.required, Validators.minLength(11), Validators.maxLength(15)]);
        this.vld_NameReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_CorreoReceptorNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_TelefonoReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_DireccionReceptorNuevo = new FormControl({value: ''}, [Validators.nullValidator]);


        this.vld_codigoProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_descripcionProductoNuevo = new FormControl({value: ''}, [Validators.required]);
        this.vld_valorProductoNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_recargoConsumoPorcentaje = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_descuentoGlobalPorcentaje = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_notesOnTheReceipt = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_purchaseOrder = new FormControl({value: ''}, [Validators.nullValidator]);

        this.vld_additionalTempKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalTempValue = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentKey = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_additionalPermanentValue = new FormControl({value: ''}, [Validators.nullValidator]);
    }

    createFormBoleta() {
        this.formBoleta = this.fb.group({
            'serie': this.vld_serie,
            'formaPago': this.vld_formaPago,
            'moneda': this.vld_moneda,
            'serviDetraccion': this.vld_servicioDetraccion,
            'rucReceptor': this.vld_rucReceptor,
            'fechaEmision': this.vld_fecha_vencimiento,
            'items': this.fb.array([]),
            'item': this.vld_item,
            'recargoConsumoPorcentaje': this.vld_recargoConsumoPorcentaje,
            'descuentoGlobalPorcentaje': this.vld_descuentoGlobalPorcentaje,
            'tasaDetrac': this.vld_tasaDetrac,
            'medPago': this.vld_medPago,
            'tasaReten': this.vld_tasaReten,
            'cuenta': this.vld_cuenta,
            'cuotas': this.vld_cuotas,
            'otrasDeducciones': this.vld_otrasDeducciones,
            'montoPagado': this.vld_montoPagado,
            'purchaseOrder': this.vld_purchaseOrder,
            'tipoCamb': this.vld_tipoCamb,
            'notesOnTheReceipt': this.vld_notesOnTheReceipt,
        });

        this.formAdditionalPermanent = this.fb.group({
            'key': this.vld_additionalPermanentKey,
            'value': this.vld_additionalPermanentValue,
        });
        this.formAdditionalTemp = this.fb.group({
            'key': this.vld_additionalTempKey,
            'value': this.vld_additionalTempValue,
        });
    }


    createFormReceptor() {
        this.formReceptor = this.fb.group({
            'razonSocial': this.vld_aux_razonSocial,
            'correoReceptor': this.vld_aux_correo,
            'direccionReceptor': this.vld_aux_direccion,
            'telefonoReceptor': this.vld_aux_telefono
        });
    }

    changeAmountOrDate() {
        this.formChangeAmountOrDate = this.fb.group({
            'monto': this.vld_changeMonto,
            'fecha': this.vld_changeDate
        });
    }

    createFormReceptorNuevo() {
        this.formReceptorNuevo = this.fb.group({
            'idDocType': this.vld_tipoReceptorNuevo,
            'idDocNumber': this.vld_rucReceptorNuevo,
            'businessName': this.vld_NameReceptorNuevo,
            'email': this.vld_CorreoReceptorNuevo,
            'phone': this.vld_TelefonoReceptorNuevo,
            'address': this.vld_DireccionReceptorNuevo
        });
    }

    createFormProductoNuevo() {
        this.formProductoNuevo = this.fb.group({
            'codigo': this.vld_codigoProductoNuevo,
            'descripcion': this.vld_descripcionProductoNuevo,
            'valor': this.vld_valorProductoNuevo
        });
    }


    createItem(): FormGroup {
        return this.fb.group({
            'codigo': '',
            'description': '',
            'cantidad': '',
            'unidad': '',
            'valor': '',
            'descuento': '',
            'igv': '',
            'precioVentaUnitario': '',
            'valorTotal': '',
        });
    }

    removeItem(pos) {
        this.template_boleta.boleta.det.splice(pos, 1);
        this.items.removeAt(pos);

        $.each(this.template_boleta.boleta.det, (pos1, item) => {
            item.numeroItem = pos1 + 1;
        });

        this.calcularCuota();
    }

    onSubmitBoleta(tipo) {
        this.error = false;
        this.mensaje = '';
        if (this.formBoleta.valid) {
            this.generarDocumentoBoleta(tipo);
        } else {
            swal(
                'Campos obligatorios',
                'Debe completar todo los campos con (*)',
                'error'
            );
        }
    }

    cargarFormaPago(fp) {
        this.template_boleta.boleta.ide.formaPago = fp;
        this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).format('YYYY-MM-DD');
        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            this.calcularCuota();
        }
    }

    changeFechaEmision() {
        this.template_boleta.boleta.ide.fechaVencimiento =
            moment(this.template_boleta.boleta.ide.fechaEmision).format('YYYY-MM-DD');
        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            this.calcularCuota();
        }
    }

    generarPreview() {
        this.generatePreCreateDocument();
        this.preview = true;
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

    getTotalLetter() {
        const body = JSON.stringify({
            montoPendientePago: this.template_boleta.boleta.cab.importeTotal,
            currency: this.template_boleta.boleta.ide.tipoMoneda,
        });
        this.consumerService.post(WebServices.URL_GET_TOTAL_LETTER, body).subscribe(result => {
            this.totalLetter = result['responseMessage'];
            this.cd.markForCheck();
            this.cd.detectChanges();

        }, err => {
            console.log('ERROR' + err);
        });
    }

    private generatePreCreateDocument() {

        this.print = true;
        this.generarADI();
        this.totalRetencionTasa();
        this.totalDescuentoGlobal();


        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            this.template_boleta.boleta.ide.montoNetoPendientePago = this.getMontoNetoPendientePago().toString();
            this.template_boleta.boleta.ide.fechaVencimiento =
                this.template_boleta.boleta.cuo[this.template_boleta.boleta.cuo.length - 1].fechaPago;
        }
        this.getTotalLetter();

    }

    printDiv() {
        const div = document.getElementById('contenedor-ticket');
        const newWindow = window.open();
        newWindow.document.write(div.innerHTML);
        newWindow.print();
        newWindow.close();
    }


    generarDocumentoBoleta(tipo) {
        this.generatePreCreateDocument();

        this.template_boleta = this.util.removeAllBlankOrNull_asString(this.template_boleta);
        const body: any = {
            invoiceTemplate: {
                boleta: this.template_boleta.boleta
            },
            documentType: this.tipoDoc,
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc
            }
        };
        const typeOperationId = this.getIdTypeOperation();
        body.invoiceTemplate.boleta.cab.tipoOperacion = this.getCodeTypeOperation();

        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            body.invoiceTemplate.boleta.ide.formaPago = 'Credito';
        }
        // Limpiar \n
        body.invoiceTemplate.boleta.adi.forEach(item => {
            if (item.tituloAdicional === 'Guias de Remisión Remitente' || item.tituloAdicional === 'Guias de Remisión Transportista') {
                item.valorAdicional = item.valorAdicional.replace('\n', ',')
                    .replace('\n', ',').replace('\n', ',').replace('\n', ',')
                    .replace('\n', ',').replace('\n', ',').replace('\n', ',');
                if (item.valorAdicional.endsWith(',')) {
                    item.valorAdicional = item.valorAdicional.substr(0, (item.valorAdicional.length - 1));
                }
            }
        });

        const req = this.limpiarCab(body);
        this.loading_documento = true;
        this.cd.markForCheck();
        this.cd.detectChanges();
        this.consumerService.create(WebServices.URL_GENERAR_DOCUMENTOS, req)
            .subscribe(result => {
                this.loading_documento = false;
                this.scroll('listDocuments');
                this.cd.markForCheck();
                this.cd.detectChanges();
                if (result.codigo !== 1) {
                    swal(
                        'No se pudo crear la boleta',
                        result.codigo + ' - ' + result.mensaje,
                        'error'
                    );
                    this.operationType.forEach(item => {
                        if (item.id === typeOperationId) {
                            this.template_boleta.boleta.cab.tipoOperacion = item.description;
                        }
                    });
                } else {
                    this.servicioDetraccion = '';
                    this.consumerService.updateNroBanco(WebServices.URL_UPDATE_NRO_BANCO.toString() +
                        this.nroCuenta).subscribe((resultUpdateNroBanco: any) => {
                        this.usuarioSession.customer.cuentaBanco = this.nroCuenta;
                        this.util.setCurrentUser(this.usuarioSession);
                    });
                    this.messageCreation = result.mensaje;
                    this.template_boleta.boleta.ide.numeracion = getDocumentInfo(result.mensaje, 'B')
                    this.showCreationSummary = true;
                    this.getIdByName(this.template_boleta.boleta.ide.numeracion);
                }

                this.setStep(0);
                this.preview = false;
                this.cd.markForCheck();
                this.cd.detectChanges();
            }, err => {
                this.operationType.forEach(item => {
                    if (item.id === typeOperationId) {
                        this.template_boleta.boleta.cab.tipoOperacion = item.description;
                    }
                });
                this.loading_documento = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el documento', this.router);
            });
    }


    private resetDocument(event) {
        this.template_boleta = this.nuevaBoleta();

        this.messageCreation = '';
        this.template_boleta.boleta.ide.formaPago = 'Contado';
        this.nroCuotas = 1;
        this.tipoCambio = '';
        this.descuentoGlobal = 0;
        this.poseeCargoDescuento = false;
        this.recargoConsumoPorcentaje = 0;
        // SE DEFINE QUE TIPO OPERACION VENTA INTERNA VA DE PRIMERO
        this.template_boleta.boleta.cab.tipoOperacion =
            this.operationType.filter(value => value.id === this.TIPO_OPERACION_VENTA_INTERNA)[0].description;
        this.showCreationSummary = false;
        this.preview = false;
        this.cd.markForCheck();
        this.cd.detectChanges();
    }


    limpiarCab(body) {
        if (this.EXPORTACION_BIEN === this.getIdTypeOperation() || this.EXPORTACION_SERVICIO === this.getIdTypeOperation()) {
            body.invoiceTemplate.boleta.cab.inafectas = null;
            body.invoiceTemplate.boleta.cab.exoneradas = null;
        } else if (this.DETRACCION === this.getIdTypeOperation()) {
            body.invoiceTemplate.boleta.cab.exportadas = null;
        } else {
            body.invoiceTemplate.boleta.cab.exportadas = null;
        }
        if (!body.invoiceTemplate.boleta.cab.gravadas) {
            body.invoiceTemplate.boleta.cab.gravadas = new Option('1001', 0.0);
        }
        return body;
    }


    getSeries() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.loadingConsultas[0].cargando = true;
        this.consumerService.update(WebServices.URL_GET_SERIES, body).subscribe(x => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            let emisorConfig: BillingConfiguration[] = x['billingConfigurationsList'];
            emisorConfig = emisorConfig.filter(xx => xx.documentType === TipoDocumento.TICKET);
            if (emisorConfig.length === 0) {
                swal({
                    title: 'Obligatorio',
                    text: 'Debe configurar al menos una serie para la boleta del emisor ' +
                        this.util.getCurrentUser().customer.nombre + ' - ' + this.util.getCurrentUser().customer.ruc,
                    type: 'warning',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 3000
                });
                setTimeout(() => {
                    const filtro: any = {};
                    filtro.busqueda = this.util.getCurrentUser().customer.ruc;
                    $('ul#slide-out').removeClass('open');
                    $('i.cerrarAleta').removeClass('open');
                    $('.closePopupNotaDebito').click();
                    this.router.navigate(['/content', {outlets: {'second': ['emisor', this.util.getCurrentUser().customer.id]}}]);
                }, 3000);
            } else {
                for (const ec of emisorConfig) {
                    this.options.push(ec.serialNumber);
                }
                if (this.options.length === 1) {
                    this.vld_serie.setValue(this.options[0]);
                }

            }
        }, err => {
            this.loadingConsultas[0].cargando = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }

    getUnit() {
        this.consumerService.update(WebServices.URL_GET_UNITS).subscribe(result => {
            this.measurementUnits = [];
            $.each(result['units'], (pos, item) => {
                if (pos < 20) {
                    this.measurementUnits.push(item);
                }
            });

        }, err => {
            console.log('ERROR' + err);
            swal({
                title: 'Error',
                text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });

        });
    }

    getCatalogos() {
        this.consumerService.post(WebServices.URL_GET_CATALOG).subscribe((result: any) => {
            this.operationType = [];
            this.catalogues = [];
            this.servicioDetraccionList = [];
            this.medioPagoList = [];
            if (result.codigo === 1) {
                result.grlcatalogues.map(item => item.description = item.code + ' - ' + item.description);
                this.catalogues = result.grlcatalogues;
                this.operationType = result.grlcatalogues.filter(
                    item => item.catalogueCode === this.CAtALOGO_51 && item.status === this.CATALOGE_ACTIVE);
                this.servicioDetraccionList = result.grlcatalogues.filter(
                    item => item.catalogueCode === this.CAtALOGO_54 && item.status === this.CATALOGE_ACTIVE);
                this.medioPagoList = result.grlcatalogues.filter(
                    item => item.catalogueCode === this.CAtALOGO_59 && item.status === this.CATALOGE_ACTIVE);

                this.medioPago = this.medioPagoList[0].description;

                this.operationType.sort(function (a, b) {
                    return a.code - b.code;
                });
                this.servicioDetraccionList.sort(function (a, b) {
                    return a.code - b.code;
                });
                this.medioPagoList.sort(function (a, b) {
                    return a.code - b.code;
                });
                // SE DEFINE QUE TIPO OPERACION VENTA INTERNA VA DE PRIMERO
                this.template_boleta.boleta.cab.tipoOperacion =
                    this.operationType.filter(value => value.id === this.TIPO_OPERACION_VENTA_INTERNA)[0].description;
            }
        }, err => {
            console.log('ERROR' + err);
            swal({
                title: 'Error',
                text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });

        });
    }

    agregarItemLista(itemCargado) {

        const itemNew = new Item();
        const porcentaje = (itemCargado.affectationIGV === 'GRAVADO') ? this.IGV : 0;

        itemNew.affectationIGV = itemCargado.affectationIGV;
        itemNew.numeroItem = this.template_boleta.boleta.det.length + 1;
        itemNew.cantidadItems = 1.000;
        itemNew.descripcionProducto = itemCargado.description;
        itemNew.codigoProducto = itemCargado.productCode;
        itemNew.unidad = itemCargado.measurementUnit.code;
        itemNew.valorUnitario = itemCargado.unitPrice;
        itemNew.precioVentaUnitario = (itemCargado.affectationIGV === 'GRAVADO') ? itemNew.valorUnitario * (this.IGV / 100 + 1) : itemNew.valorUnitario;
        let stringValor = parseFloat(itemNew.precioVentaUnitario.toString()).toFixed(10);
        itemNew.precioVentaUnitario = parseFloat(stringValor) * 1.00;
        itemNew.valorVenta = itemNew.valorUnitario * itemNew.cantidadItems;


        const impuesto = new Impuesto();
        impuesto.porcentaje = porcentaje.toString();
        impuesto.montoImpuesto = (itemNew.precioVentaUnitario - itemNew.valorUnitario) * itemNew.cantidadItems;
        stringValor = parseFloat(impuesto.montoImpuesto.toString()).toFixed(2);
        impuesto.montoImpuesto = parseFloat(stringValor) * 1.00;
        stringValor = parseFloat(itemNew.valorVenta.toString()).toFixed(2);
        impuesto.montoBase = parseFloat(stringValor) * 1.00;

        itemNew.totalImpuestos = [];
        itemNew.totalImpuestos.push(impuesto);

        itemNew.montoTotalImpuestos = impuesto.montoImpuesto;

        if (this.getIdTypeOperation() === this.EXPORTACION_BIEN || this.EXPORTACION_SERVICIO === this.getIdTypeOperation()) {
            this.updateToExportada(itemNew);
        } else if (this.getIdTypeOperation() === this.DETRACCION) {
            this.updateToIGV(itemNew);
        } else {
            if (itemCargado.affectationIGV === 'GRAVADO'
                || itemCargado.affectationIGV === 'EXPORTADO'
                || this.poseeDescuentoGlobal || this.poseeDescuentoItem()) {
                this.updateToIGV(itemNew);
            } else if (itemCargado.affectationIGV === 'INAFECTO') {
                this.updateToInafecta(itemNew);
                this.poseeDescuentoGlobalDiv = false;
            } else if (itemCargado.affectationIGV === 'EXONERADO') {
                this.updateToExonerada(itemNew);
                this.poseeDescuentoGlobalDiv = false;
            }
        }

        this.scroll('div_datosCliente');
        this.template_boleta.boleta.det.push(itemNew);
        this.items = this.formBoleta.get('items') as FormArray;
        this.items.push(this.createItem());
    }


    updateToInafecta(item) {
        if (this.poseeDescuentoItem() || this.poseeDescuentoGlobal) {
            this.snackBar.open('Si tienes aplicado algun descuento, solo puedes agregar item con IGV.', null, {duration: 2000});
            return false;
        }
        if (this.amountWithIGV) {
            item.valorUnitario = item.precioVentaUnitario;
        } else {
            item.precioVentaUnitario = item.valorUnitario;
        }
        item.totalImpuestos[0].tipoAfectacion = '30';
        item.totalImpuestos[0].idImpuesto = '9998';
        item.totalImpuestos[0].porcentaje = '0';
        item.totalImpuestos[0].montoImpuesto = 0.0;
        item.totalImpuestos[0].montoBase = 0.0;
        item.affectationIGV = 'INAFECTO';
        item.montoTotalImpuestos = 0;
        item.montoImpuesto = 0;
        item.descuento = 0;
        this.refresh(item);
    }

    updateToExonerada(item) {
        if (this.poseeDescuentoItem() || this.poseeDescuentoGlobal) {
            this.snackBar.open('Si tienes aplicado algun descuento, solo puedes agregar item con IGV.', null, {duration: 2000});
            return false;
        }
        if (this.amountWithIGV) {
            item.valorUnitario = item.precioVentaUnitario;
        } else {
            item.precioVentaUnitario = item.valorUnitario;
        }
        item.totalImpuestos[0].tipoAfectacion = '20';
        item.totalImpuestos[0].idImpuesto = '9997';
        item.totalImpuestos[0].porcentaje = '0';
        item.totalImpuestos[0].montoImpuesto = 0.0;
        item.totalImpuestos[0].montoBase = 0.0;
        item.affectationIGV = 'EXONERADO';
        item.montoTotalImpuestos = 0;
        item.montoImpuesto = 0;
        item.descuento = 0;
        this.refresh(item);
    }

    updateToExportada(item) {
        if (this.poseeDescuentoItem() || this.poseeDescuentoGlobal) {
            this.snackBar.open('Si tienes aplicado algun descuento, solo puedes agregar item con IGV.', null, {duration: 2000});
            return false;
        }
        if (this.amountWithIGV) {
            item.valorUnitario = item.precioVentaUnitario;
        } else {
            item.precioVentaUnitario = item.valorUnitario;
        }
        item.totalImpuestos[0].tipoAfectacion = '40';
        item.totalImpuestos[0].idImpuesto = '9995';
        item.totalImpuestos[0].porcentaje = '0';
        item.totalImpuestos[0].montoImpuesto = 0.0;
        item.totalImpuestos[0].montoBase = 0.0;
        item.affectationIGV = 'EXPORTADO';
        item.montoTotalImpuestos = 0;
        item.montoImpuesto = 0;
        item.descuento = 0;
        this.refresh(item);
    }

    updateToIGV(item) {
        let stringValor;
        if (this.amountWithIGV) {
            item.valorUnitario = item.precioVentaUnitario / (this.IGV / 100 + 1);
            stringValor = parseFloat(item.valorUnitario.toString()).toFixed(2);
            item.valorUnitario = parseFloat(stringValor);
        } else {
            item.precioVentaUnitario = item.valorUnitario * (this.IGV / 100 + 1);
            stringValor = parseFloat(item.precioVentaUnitario.toString()).toFixed(10);
            item.precioVentaUnitario = parseFloat(stringValor) * 1.00;
        }
        item.totalImpuestos[0].tipoAfectacion = '10';
        item.totalImpuestos[0].idImpuesto = '1000';
        item.totalImpuestos[0].porcentaje = this.IGV;
        item.affectationIGV = 'GRAVADO';
        item.descuento = 0;
        item.totalImpuestos[0].montoImpuesto = (item.precioVentaUnitario - item.valorUnitario) * item.cantidadItems;
        stringValor = parseFloat(item.totalImpuestos[0].montoImpuesto.toString()).toFixed(2);
        item.totalImpuestos[0].montoImpuesto = parseFloat(stringValor) * 1.00;
        stringValor = parseFloat(item.valorVenta.toString()).toFixed(2);
        item.totalImpuestos[0].montoBase = parseFloat(stringValor) * 1.00;
        this.refresh(item);
    }

    private refresh(item) {
        this.totalRefresh();
        this.recalcular(item, 'VALOR_UNITARIO');
    }

    totalRefresh() {
        this.totalGravadas();
        this.totalExoneradas();
        this.totalExportadas();
        this.totalInafectas();
        this.totalDescuentoGlobal();
        this.totalImpuesto();
        this.totalCalculado();

    }

    validarExistenciaItem(value: string) {
        let existe = false;
        $.each(this.template_boleta.boleta.det, (pos, item) => {
            if (((item.codigoProducto + ' - ' + item.descripcionProducto) === this.aux_item)) {
                existe = true;
            }
        });
        return existe;
    }

    pad(num: Number, size: number): string {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }

    editReceptor() {
        this.aux_correo = this.template_boleta.boleta.rec.correoElectronico;
        this.aux_telefono = this.template_boleta.boleta.rec.telefono;
        this.aux_direccion = this.template_boleta.boleta.rec.direccion;
        this.aux_razonSocial = this.template_boleta.boleta.rec.razonSocial;
        this.editarReceptor = true;
    }

    guardarCambios() {
        this.template_boleta.boleta.rec.correoElectronico = this.aux_correo;
        this.template_boleta.boleta.rec.telefono = this.aux_telefono;
        this.template_boleta.boleta.rec.direccion = this.aux_direccion;
        this.template_boleta.boleta.rec.razonSocial = this.aux_razonSocial;
        this.editarReceptor = false;
    }

    deshacerCambios() {
        this.aux_correo = this.template_boleta.boleta.rec.correoElectronico;
        this.aux_telefono = this.template_boleta.boleta.rec.telefono;
        this.editarReceptor = false;
    }

    recalcular(detalle, campoModifica) {
        const stringValor = '';
        if (detalle.descuento == 0 || detalle.descuento === '0.00' || detalle.descuento === '') {
            this.recalcularSinDescuento(campoModifica, detalle, stringValor);
        } else {
            this.recalcularConDescuento(campoModifica, detalle, stringValor);
        }
        this.calcularCuota();
        this.totalRefresh();

    }

    descuentoKeyUp($event, campo, i) {
        this.imposeMinMax($event, campo, i);
        this.recalcular(this.template_boleta.boleta.det[i], ((this.amountWithIGV) ? 'PRECIO_UNITARIO' : 'VALOR_UNITARIO'));
    }

    private recalcularConDescuento(campoModifica, detalle, stringValor: string) {
        let unitarioConDescuento = 0;

        if (campoModifica === 'VALOR_UNITARIO') {
            if ((detalle.affectationIGV === 'GRAVADO')) {
                detalle.cargoDescuento = [];
                const cargoDescuento = new CargoDescuento();
                cargoDescuento.codigoCargoDescuento = '00';
                cargoDescuento.indicadorCargoDescuento = false;
                cargoDescuento.factorCargoDescuento = detalle.descuento / 100;
                const stringValor2 = parseFloat(cargoDescuento.factorCargoDescuento.toString()).toFixed(5);
                cargoDescuento.factorCargoDescuento = parseFloat(stringValor2) * 1.00;

                cargoDescuento.montoBaseCargoDescuento = detalle.valorUnitario * detalle.cantidadItems;
                stringValor = parseFloat(cargoDescuento.montoBaseCargoDescuento.toString()).toFixed(2);
                cargoDescuento.montoBaseCargoDescuento = parseFloat(stringValor);

                cargoDescuento.montoCargoDescuento = (cargoDescuento.montoBaseCargoDescuento * detalle.descuento / 100);
                stringValor = parseFloat(cargoDescuento.montoCargoDescuento.toString()).toFixed(2);
                cargoDescuento.montoCargoDescuento = parseFloat(stringValor);


                unitarioConDescuento = detalle.valorUnitario - (detalle.valorUnitario * detalle.descuento / 100)

                detalle.precioVentaUnitario = unitarioConDescuento * (this.IGV / 100 + 1);

                detalle.valorVenta = (detalle.affectationIGV === 'GRAVADO') ? (unitarioConDescuento * detalle.cantidadItems) : (detalle.valorUnitario * detalle.cantidadItems);
                stringValor = parseFloat(detalle.valorVenta.toString()).toFixed(2);
                detalle.valorVenta = parseFloat(stringValor);
                detalle.cargoDescuento.push(cargoDescuento);
            } else {

                detalle.valorVenta = (detalle.affectationIGV === 'GRAVADO') ? (detalle.valorUnitario * detalle.cantidadItems) : (detalle.valorUnitario * detalle.cantidadItems);
                stringValor = parseFloat(detalle.valorVenta.toString()).toFixed(2);
                detalle.valorVenta = parseFloat(stringValor);
                detalle.precioVentaUnitario = detalle.valorUnitario;
            }
            stringValor = parseFloat(detalle.precioVentaUnitario.toString()).toFixed(10);
            detalle.precioVentaUnitario = parseFloat(stringValor) * 1.00;

        } else {
            if ((detalle.affectationIGV === 'GRAVADO')) {
                detalle.valorUnitario = (detalle.precioVentaUnitario / (this.IGV / 100 + 1)) / (detalle.descuento / 100);
                // TODO FALTA CALCULO
                /*cargoDescuento =  new CargoDescuento();
                cargoDescuento.codigoCargoDescuento = '00';
                cargoDescuento.indicadorCargoDescuento = false;
                cargoDescuento.factorCargoDescuento = detalle.descuento / 100;
                cargoDescuento.montoBaseCargoDescuento = detalle.valorUnitario;*/
            } else {
                detalle.valorUnitario = detalle.precioVentaUnitario;
            }

            stringValor = parseFloat(detalle.valorUnitario.toString()).toFixed(10);
            detalle.valorUnitario = parseFloat(stringValor);

            unitarioConDescuento = detalle.valorUnitario - (detalle.valorUnitario * detalle.descuento / 100)
            detalle.valorVenta = (detalle.affectationIGV === 'GRAVADO') ? (unitarioConDescuento * detalle.cantidadItems) : (detalle.valorUnitario * detalle.cantidadItems);
            stringValor = parseFloat(detalle.valorVenta.toString()).toFixed(2);
            detalle.valorVenta = parseFloat(stringValor);

        }


        detalle.totalImpuestos[0].montoImpuesto = (detalle.affectationIGV === 'GRAVADO') ?
            (detalle.precioVentaUnitario - unitarioConDescuento) * detalle.cantidadItems :
            (detalle.precioVentaUnitario - detalle.valorUnitario) * detalle.cantidadItems;

        stringValor = parseFloat(detalle.totalImpuestos[0].montoImpuesto.toString()).toFixed(2);
        detalle.totalImpuestos[0].montoImpuesto = parseFloat(stringValor) * 1.00;

        stringValor = parseFloat(detalle.totalImpuestos[0].montoImpuesto.toString()).toFixed(2);
        detalle.totalImpuestos[0].montoImpuesto = parseFloat(stringValor) * 1.00;

        detalle.totalImpuestos[0].montoBase = detalle.valorVenta;

        detalle.montoTotalImpuestos = detalle.totalImpuestos[0].montoImpuesto;
    }

    private recalcularSinDescuento(campoModifica, detalle, stringValor: string) {
        detalle.cargoDescuento = null;
        if (campoModifica === 'VALOR_UNITARIO') {
            detalle.precioVentaUnitario = (detalle.affectationIGV === 'GRAVADO') ? detalle.valorUnitario * (this.IGV / 100 + 1) : detalle.valorUnitario;
            stringValor = parseFloat(detalle.precioVentaUnitario.toString()).toFixed(10);
            detalle.precioVentaUnitario = parseFloat(stringValor) * 1.00;
        } else {
            detalle.valorUnitario = (detalle.affectationIGV === 'GRAVADO') ?
                detalle.precioVentaUnitario / (this.IGV / 100 + 1) : detalle.precioVentaUnitario;
            stringValor = parseFloat(detalle.valorUnitario.toString()).toFixed(2);
            detalle.valorUnitario = parseFloat(stringValor);
        }

        detalle.valorVenta = detalle.valorUnitario * detalle.cantidadItems;
        detalle.totalImpuestos[0].montoImpuesto =
            (detalle.precioVentaUnitario - detalle.valorUnitario) * detalle.cantidadItems;

        stringValor = parseFloat(detalle.totalImpuestos[0].montoImpuesto.toString()).toFixed(2);
        detalle.totalImpuestos[0].montoImpuesto = parseFloat(stringValor) * 1.00;


        stringValor = parseFloat(detalle.valorVenta.toString()).toFixed(2);
        detalle.valorVenta = parseFloat(stringValor);

        stringValor = parseFloat(detalle.totalImpuestos[0].montoImpuesto.toString()).toFixed(2);
        detalle.totalImpuestos[0].montoImpuesto = parseFloat(stringValor) * 1.00;

        detalle.montoTotalImpuestos = detalle.totalImpuestos[0].montoImpuesto;

        detalle.totalImpuestos[0].montoBase = detalle.valorVenta;
    }

    totalImpuesto() {
        if (this.template_boleta.boleta.cab.gravadas && this.template_boleta.boleta.cab.gravadas.totalVentas) {
            //return this.totalGravadas() * (this.IGV/100);
            return this.template_boleta.boleta.cab.montoTotalImpuestos;
        }
        return 0;
    }

    totalRecargoConsumo() {
        if (this.poseeCargoDescuento) {
            const operacionesGravadas = this.totalGravadas();
            const cargoDescuento = new CargoDescuento();
            cargoDescuento.factorCargoDescuento = this.recargoConsumoPorcentaje / 100;
            let stringValor = parseFloat(cargoDescuento.factorCargoDescuento.toString()).toFixed(5);
            cargoDescuento.factorCargoDescuento = parseFloat(stringValor) * 1.00;

            cargoDescuento.montoBaseCargoDescuento = operacionesGravadas;

            cargoDescuento.montoCargoDescuento = operacionesGravadas * cargoDescuento.factorCargoDescuento;
            stringValor = parseFloat(cargoDescuento.montoCargoDescuento.toString()).toFixed(2);
            cargoDescuento.montoCargoDescuento = parseFloat(stringValor) * 1.00;


            if (!this.template_boleta.boleta.cab.cargoDescuento) {
                this.template_boleta.boleta.cab.cargoDescuento = [];
            }

            this.setCargoConsumo('46', cargoDescuento);
            this.template_boleta.boleta.cab.sumOtrosCargos = cargoDescuento.montoCargoDescuento;

            return cargoDescuento.montoCargoDescuento;
        } else {
            this.template_boleta.boleta.cab.sumOtrosCargos = null;
        }
        return 0;
    }

    totalRetencionTasa() {
        if (this.getIdTypeOperation() === this.RETENCION) {
            const cargoDescuento = new CargoDescuento();
            cargoDescuento.codigoCargoDescuento = '62';
            cargoDescuento.indicadorCargoDescuento = false;
            cargoDescuento.factorCargoDescuento = parseFloat(this.tasaRetencion) / 100;
            let stringValor = parseFloat(cargoDescuento.factorCargoDescuento.toString()).toFixed(5);
            cargoDescuento.factorCargoDescuento = parseFloat(stringValor) * 1.00;

            cargoDescuento.montoCargoDescuento = this.template_boleta.boleta.cab.importeTotal * (parseFloat(this.tasaRetencion) / 100);
            stringValor = parseFloat(cargoDescuento.montoCargoDescuento.toString()).toFixed(2);
            cargoDescuento.montoCargoDescuento = parseFloat(stringValor) * 1.00;
            cargoDescuento.montoBaseCargoDescuento = this.template_boleta.boleta.cab.importeTotal;
            if (!this.template_boleta.boleta.cab.cargoDescuento) {
                this.template_boleta.boleta.cab.cargoDescuento = [];
            }
            this.setCargoConsumo(cargoDescuento.codigoCargoDescuento, cargoDescuento);
            this.template_boleta.boleta.cab.sumOtrosCargos = 0;
        }
    }

    setCargoConsumo(codigoCargoDescuento, cargoDescuento) {
        let pos = this.getCargoDescuentoPos(codigoCargoDescuento)
        if (pos !== -99) {
            this.template_boleta.boleta.cab.cargoDescuento[pos] = cargoDescuento;
        } else {
            this.template_boleta.boleta.cab.cargoDescuento.push(cargoDescuento);
        }
    }

    poseeDescGlobal() {
        if (this.descuentoGlobal !== 0 && this.descuentoGlobal !== 0) {
            return true;
        }
        return false;
    }

    getCargoDescuento(codigoCargoDescuento) {
        let cargoDescuento = null;
        if (this.template_boleta.boleta.cab.cargoDescuento) {
            cargoDescuento = this.template_boleta.boleta.cab.cargoDescuento.filter(item => item.codigoCargoDescuento === codigoCargoDescuento);
        }
        return cargoDescuento;
    }

    getCargoDescuentoPos(codigoCargoDescuento) {
        let cargoDescuentoPos = -99;
        if (this.template_boleta.boleta.cab.cargoDescuento) {
            this.template_boleta.boleta.cab.cargoDescuento.forEach((item, pos) => {
                if (item.codigoCargoDescuento === codigoCargoDescuento) {
                    cargoDescuentoPos = pos;
                }
            });
        }
        return cargoDescuentoPos;
    }

    poseeDescuentoItem() {
        let posee = false;
        this.template_boleta.boleta.det.forEach(item => {
            if (item.descuento != 0 || item.descuento != '') {
                posee = true;
            }
        });
        return posee;
    }

    isDescuentoGlobalDiv() {
        if (this.getIdTypeOperation() == this.EXPORTACION_BIEN || this.getIdTypeOperation() == this.EXPORTACION_SERVICIO) {
            this.poseeDescuentoGlobalDiv = false;
            this.poseeDescuentoGlobal = false;
            this.descuentoGlobal = 0;
            return this.poseeDescuentoGlobal;
        }
        if (this.descuentoGlobal > 0) {
            this.poseeDescuentoGlobal = true;
        } else {
            this.poseeDescuentoGlobal = false;
        }

        let poseeItemNoDescuento = false;
        this.template_boleta.boleta.det.forEach(item => {
            if (item.affectationIGV !== 'GRAVADO') {
                poseeItemNoDescuento = true;
                this.poseeDescuentoGlobal = false;
            }
        });
        if (poseeItemNoDescuento) {
            this.descuentoGlobal = 0;
            this.poseeDescuentoGlobalDiv = false;
        } else {
            this.poseeDescuentoGlobalDiv = true;
        }

        if (this.poseeDescuentoItem() || this.poseeDescuentoGlobal) {
            this.recargoConsumoPorcentaje = 0;
        }


        return this.poseeDescuentoGlobalDiv;
    }

    totalDescuentoGlobal() {
        if (this.poseeDescGlobal()) {
            let operacionesGravadas = 0.0;
            const cargoDescuento = new CargoDescuento();
            cargoDescuento.codigoCargoDescuento = '02';
            cargoDescuento.indicadorCargoDescuento = false;

            cargoDescuento.factorCargoDescuento = this.descuentoGlobal / 100;
            let stringValor = parseFloat(cargoDescuento.factorCargoDescuento.toString()).toFixed(5);
            cargoDescuento.factorCargoDescuento = parseFloat(stringValor) * 1.00;

            $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                if (detalle.affectationIGV === 'GRAVADO') {
                    operacionesGravadas += detalle.valorVenta;
                }
            });

            cargoDescuento.montoCargoDescuento = operacionesGravadas * (this.descuentoGlobal / 100);
            stringValor = parseFloat(cargoDescuento.montoCargoDescuento.toString()).toFixed(2);
            cargoDescuento.montoCargoDescuento = parseFloat(stringValor) * 1.00;

            cargoDescuento.montoBaseCargoDescuento = operacionesGravadas;
            if (!this.template_boleta.boleta.cab.cargoDescuento) {
                this.template_boleta.boleta.cab.cargoDescuento = [];
            }
            this.setCargoConsumo(cargoDescuento.codigoCargoDescuento, cargoDescuento);
            return cargoDescuento.montoCargoDescuento;
        } else {
            let pos = this.getCargoDescuentoPos("02");
            if (pos !== -99) {
                this.template_boleta.boleta.cab.cargoDescuento.splice(pos, 1);
            }

        }
        return 0;
    }

    totalGravadas() {
        const impuestoGravada = new Impuesto();
        impuestoGravada.idImpuesto = 1000;
        impuestoGravada.montoImpuesto = 0.0;
        impuestoGravada.montoImpuesto = 0.0;
        impuestoGravada.tipoAfectacion = null;

        // CALCULAR EL TOTAL DE VENTAS E IMPUESTOS
        this.template_boleta.boleta.cab.totalImpuestos = [];
        if (this.template_boleta.boleta.det.filter(item => item.affectationIGV === 'GRAVADO').length > 0) {
            this.template_boleta.boleta.cab.gravadas = new Option('1001', 0.0);
            let stringValor = '';

            if (this.poseeDescGlobal()) {
                let cargoDescuento = this.getCargoDescuento('02');
                $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                    if (detalle.affectationIGV === 'GRAVADO') {
                        this.template_boleta.boleta.cab.gravadas.totalVentas += detalle.valorVenta;
                    }
                });
                if (cargoDescuento) {
                    this.template_boleta.boleta.cab.gravadas.totalVentas -=
                        this.template_boleta.boleta.cab.gravadas.totalVentas * (this.descuentoGlobal / 100);

                    stringValor = parseFloat(this.template_boleta.boleta.cab.gravadas.totalVentas.toString()).toFixed(2);
                    this.template_boleta.boleta.cab.gravadas.totalVentas = parseFloat(stringValor) * 1.00;

                    impuestoGravada.montoImpuesto = this.template_boleta.boleta.cab.gravadas.totalVentas * (this.IGV / 100);
                    stringValor = parseFloat(impuestoGravada.montoImpuesto.toString()).toFixed(2);
                    impuestoGravada.montoImpuesto = parseFloat(stringValor) * 1.00;
                    this.template_boleta.boleta.cab.montoTotalImpuestos = impuestoGravada.montoImpuesto;
                    this.template_boleta.boleta.cab.totalImpuestos.push(impuestoGravada);

                }
            } else {
                $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                    if (detalle.affectationIGV === 'GRAVADO') {
                        $.each(detalle.totalImpuestos, (posImp, imp) => {
                            impuestoGravada.montoImpuesto += imp.montoImpuesto;
                        });
                        this.template_boleta.boleta.cab.gravadas.totalVentas += detalle.valorVenta;
                    }
                });

                stringValor = parseFloat(this.template_boleta.boleta.cab.gravadas.totalVentas.toString()).toFixed(2);
                this.template_boleta.boleta.cab.gravadas.totalVentas = parseFloat(stringValor) * 1.00;

                stringValor = parseFloat(impuestoGravada.montoImpuesto.toString()).toFixed(2);
                impuestoGravada.montoImpuesto = parseFloat(stringValor) * 1.00;
                this.template_boleta.boleta.cab.montoTotalImpuestos = impuestoGravada.montoImpuesto;
                this.template_boleta.boleta.cab.totalImpuestos.push(impuestoGravada);
            }

            return this.template_boleta.boleta.cab.gravadas.totalVentas;
        } else {
            this.template_boleta.boleta.cab.montoTotalImpuestos = 0;
            this.template_boleta.boleta.cab.gravadas = null;
            return 0;
        }
    }

    totalInafectas() {
        const impuestoInafecto = new Impuesto();
        impuestoInafecto.idImpuesto = 9998;
        impuestoInafecto.montoImpuesto = 0.0;
        impuestoInafecto.tipoAfectacion = null;

        // CALCULAR EL TOTAL DE VENTAS E IMPUESTOS
        if (this.template_boleta.boleta.det.filter(item => item.affectationIGV === 'INAFECTO').length > 0) {
            this.template_boleta.boleta.cab.inafectas = new Option('1002', 0.0);

            $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                if (detalle.affectationIGV === 'INAFECTO') {
                    $.each(detalle.totalImpuestos, (posImp, imp) => {
                        impuestoInafecto.montoImpuesto += imp.montoImpuesto;
                    });
                    this.template_boleta.boleta.cab.inafectas.totalVentas += detalle.valorVenta;
                }
            });
            let stringValor = '';
            stringValor = parseFloat(this.template_boleta.boleta.cab.inafectas.totalVentas.toString()).toFixed(2);
            this.template_boleta.boleta.cab.inafectas.totalVentas = parseFloat(stringValor) * 1.00;

            stringValor = parseFloat(impuestoInafecto.montoImpuesto.toString()).toFixed(2);
            impuestoInafecto.montoImpuesto = parseFloat(stringValor) * 1.00;
            this.template_boleta.boleta.cab.totalImpuestos.push(impuestoInafecto);

            return this.template_boleta.boleta.cab.inafectas.totalVentas;
        } else {
            this.template_boleta.boleta.cab.inafectas = null;
            return 0;
        }
    }

    totalExoneradas() {
        const impuestoExoneradas = new Impuesto();
        impuestoExoneradas.idImpuesto = 9997;
        impuestoExoneradas.montoImpuesto = 0.0;
        impuestoExoneradas.tipoAfectacion = null;

        // CALCULAR EL TOTAL DE VENTAS E IMPUESTOS
        if (this.template_boleta.boleta.det.filter(item => item.affectationIGV === 'EXONERADO').length > 0) {
            this.template_boleta.boleta.cab.exoneradas = new Option('1003', 0.0);
            $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                if (detalle.affectationIGV === 'EXONERADO') {
                    $.each(detalle.totalImpuestos, (posImp, imp) => {
                        impuestoExoneradas.montoImpuesto += imp.montoImpuesto;
                    });
                    this.template_boleta.boleta.cab.exoneradas.totalVentas += detalle.valorVenta;
                }
            });
            let stringValor = '';
            stringValor = parseFloat(this.template_boleta.boleta.cab.exoneradas.totalVentas.toString()).toFixed(2);
            this.template_boleta.boleta.cab.exoneradas.totalVentas = parseFloat(stringValor) * 1.00;

            stringValor = parseFloat(impuestoExoneradas.montoImpuesto.toString()).toFixed(2);
            impuestoExoneradas.montoImpuesto = parseFloat(stringValor) * 1.00;
            this.template_boleta.boleta.cab.totalImpuestos.push(impuestoExoneradas);
            return this.template_boleta.boleta.cab.exoneradas.totalVentas;
        } else {
            this.template_boleta.boleta.cab.exoneradas = null;
            return 0;
        }

    }

    totalExportadas() {
        const impuestoExoneradas = new Impuesto();
        impuestoExoneradas.idImpuesto = 9995;
        impuestoExoneradas.montoImpuesto = 0.0;
        impuestoExoneradas.tipoAfectacion = null;

        // CALCULAR EL TOTAL DE VENTAS E IMPUESTOS
        if (this.template_boleta.boleta.det.filter(item => item.affectationIGV === 'EXPORTADO').length > 0) {
            this.template_boleta.boleta.cab.exportadas = new Option('1000', 0.0);

            $.each(this.template_boleta.boleta.det, (pos, detalle) => {
                if (detalle.affectationIGV === 'EXPORTADO') {
                    $.each(detalle.totalImpuestos, (posImp, imp) => {
                        impuestoExoneradas.montoImpuesto += imp.montoImpuesto;
                    });
                    this.template_boleta.boleta.cab.exportadas.totalVentas += detalle.valorVenta;
                }
            });
            let stringValor = '';
            stringValor = parseFloat(this.template_boleta.boleta.cab.exportadas.totalVentas.toString()).toFixed(2);
            this.template_boleta.boleta.cab.exportadas.totalVentas = parseFloat(stringValor) * 1.00;

            this.template_boleta.boleta.cab.totalImpuestos.push(impuestoExoneradas);

            return this.template_boleta.boleta.cab.exportadas.totalVentas;
        } else {
            this.template_boleta.boleta.cab.exportadas = null;
            return 0;
        }
    }

    totalCalculado() {
        this.template_boleta.boleta.cab.importeTotal =
            this.totalGravadas() +
            this.totalInafectas() +
            this.totalExoneradas() +
            this.totalExportadas() +
            this.totalImpuesto() +
            this.totalRecargoConsumo();
        const stringValor = parseFloat(this.template_boleta.boleta.cab.importeTotal.toString()).toFixed(2);
        this.template_boleta.boleta.cab.importeTotal = parseFloat(stringValor) * 1.00;

        return this.template_boleta.boleta.cab.importeTotal;
    }

    totalCalculadoMontoDetraccion(): number {
        if (this.getIdTypeOperation() !== this.DETRACCION) {
            return 0;
        }
        var total = this.totalCalculado() * (parseFloat(this.tasaDetraccion) / 100)
        return parseFloat(parseFloat(total.toString()).toFixed(2))
    }

    totalCalculadoMontoRetencion(): number {
        if (this.getIdTypeOperation() !== this.RETENCION) {
            return 0;
        }
        var total = this.totalCalculado() * (parseFloat(this.tasaRetencion) / 100)
        return parseFloat(parseFloat(total.toString()).toFixed(2));
    }

    getOtrasDeduccion(): number {
        if (this.otrasDeduccion === '') {
            return 0;
        }
        return parseFloat(parseFloat(this.otrasDeduccion).toFixed(2));
    }

    getMontoPagado(): number {
        if (this.montoPagado === '') {
            return 0;
        }
        return parseFloat(parseFloat(this.montoPagado).toFixed(2));
    }

    deshabilitarBoton() {

        if (!this.formBoleta.valid) {
            return true;
        }
        if (this.template_boleta.boleta.det.length === 0) {
            return true;
        }
        if (this.agregarShowReceptor) {
            return true;
        }
        if ((this.getIdTypeOperation() === this.DETRACCION)
            &&
            this.template_boleta.boleta.ide.tipoMoneda !== 'PEN' &&
            (this.tipoCambio === undefined || this.tipoCambio === '')) {
            return true;
        }
        if ((this.getIdTypeOperation() === this.DETRACCION)
            && ((this.nroCuenta === undefined) || (this.nroCuenta === ''))) {
            return true;
        }
        return false;
    }

    divAgregarNewReceptor() {
        this.popupReceptor = true;
        this.receptorNuevo = new Receiver();
        this.receptorNuevo.idDocNumber = this.rucTmp;
        this.receptorNuevo.idDocType = this.typeDocument.value;
        this.docType = [];
        if (this.EXPORTACION_BIEN === this.getIdTypeOperation() || this.EXPORTACION_SERVICIO === this.getIdTypeOperation()) {
            this.docType.push({value: this.DND, label: 'DND'});
            this.receptorNuevo.idDocType = this.DND;
        } else if (this.DETRACCION === this.getIdTypeOperation()) {
            this.docType.push({value: this.RUC, label: 'RUC'});
            this.receptorNuevo.idDocType = this.RUC;
        } else {
            this.docType.push({value: this.DNI, label: 'DNI'});
            this.docType.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
            this.docType.push({value: this.PASAPORTE, label: 'Pasaporte'});
            this.docType.push({value: this.RUC, label: 'RUC'});
            this.docType.push({value: this.DND, label: 'DND'});
        }

    }

    divAgregarNuevoProducto() {
        this.popupProducto = true;
    }

    cerrarPopupReceptor() {
        this.popupReceptor = false;
    }

    cerrarPopupProducto() {
        this.popupProducto = false;
    }

    handlerAgregarItemLista(event) {
        this.agregarItemLista(event);
        this.cerrarPopupProducto();
    }

    handlerReceptorNuevo(event) {
        this.optionsRuc.push(event);
        this.template_boleta.boleta.rec.numeroDocId = event.idDocNumber;
        this.cerrarPopupReceptor();
    }

    private _filter(value: string): String[] {
        if (value) {
            const filterValue = value.toLowerCase();
            return this.options.filter(option => option.toLowerCase().includes(filterValue));
        }
    }


    private _filterServicioDetraccion(value: string): String[] {
        if (value) {
            const filterValue = value.toLowerCase();
            return this.servicioDetraccionList.filter(option => option.description.toLowerCase().includes(filterValue));
        }
    }

    private _filterRuc(value: string): Receiver[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        let encontre = false;
        $.each(this.optionsRuc, (pos, item) => {
            if ((item.idDocNumber === this.template_boleta.boleta.rec.numeroDocId)
                || (item.businessName === this.template_boleta.boleta.rec.numeroDocId)) {
                this.template_boleta.boleta.rec.tipoDocId = item.idDocType;
                this.template_boleta.boleta.rec.numeroDocId = item.idDocNumber;
                this.template_boleta.boleta.rec.razonSocial = item.businessName;
                this.template_boleta.boleta.rec.direccion = item.address;
                this.template_boleta.boleta.rec.telefono = item.phone;
                this.template_boleta.boleta.rec.correoElectronico = item.email;
                $('.espacioCliente').animate({
                    opacity: 1
                }, 1000);
                encontre = true;
            }
        });
        if (!encontre) {
            this.template_boleta.boleta.rec.razonSocial = null;
            this.template_boleta.boleta.rec.direccion = null;
            this.template_boleta.boleta.rec.telefono = null;
            this.template_boleta.boleta.rec.correoElectronico = null;
            $('.espacioCliente').animate({
                opacity: 0
            }, 500);
        }
        const aux = this.optionsRuc.filter(option =>
            ((option.idDocNumber.toLowerCase().includes(filterValue)) ||
                (option.businessName.toLowerCase().includes(filterValue))));
        if (aux !== null && aux.length === 0 && value != null && value.length > 0) {
            this.agregarShowReceptor = true;
        } else {
            this.agregarShowReceptor = false;
        }
        return aux;
    }

    private _filterItem(value: string): StockProducts[] {
        let filterValue = '';
        if (value != null) {
            filterValue = value.toLowerCase();
        }
        $.each(this.optionsItem, (pos, itemCargado) => {
            if (((itemCargado.productCode + ' - ' + itemCargado.description) === this.aux_item)) {
                if (!this.validarExistenciaItem(this.aux_item)) {
                    this.agregarItemLista(itemCargado);
                    this.calcularCuota();
                    this.aux_item = '';
                    this.snackBar.open('Se ha agregado un producto a la boleta.', null, {duration: 2000});
                } else {
                    this.aux_item = '';
                    this.snackBar.open('El producto ya se encuentra en la lista. Aumente la cantidad', null, {duration: 2000});
                }
            }
        });

        const aux = this.optionsItem.filter(option =>
            ((option.productCode.toLowerCase().includes(filterValue)) ||
                (option.description.toLowerCase().includes(filterValue))));
        if (aux != null && aux.length === 0 && value != null && value.length > 0) {
            this.agregarShowItem = true;
        } else {
            this.agregarShowItem = false;
        }
        return aux;
    }

    nuevaBoleta() {
        this.notesOnTheReceipt = '';
        this.guiaRemisionTransporte = [];
        this.guiaRemision = [];
        this.additionalDataTmp = [];
        const boleta: any = {
            boleta: {
                ide: new Ide(),
                emi: new Emi(this.util.getCurrentUser().customer.ruc, this.util.getCurrentUser().customer.nombre),
                rec: new Rec(),
                cab: new Cab(),
                drf: [],
                det: [],
                cuo: [],
                adi: []
            }
        };
        boleta.boleta.ide.codTipoDocumento = '03';
        boleta.boleta.ide.fechaVencimiento = moment().format('YYYY-MM-DD');
        return boleta;
    }

    getMontoCuota() {
        return parseFloat((this.getMontoNetoPendientePago() / this.nroCuotas).toString()).toFixed(2);
    }

    changeFormaPago() {
        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            this.nroCuotas = 1;
            this.calcularCuota();
        } else {
            this.nroCuotas = 1;
            this.template_boleta.boleta.cuo = [];
        }
    }


    agregarMontoPagado() {
        if (this.getMontoNetoPendientePago() < 0) {
            this.montoPagado = '0';
            return 0;

        }
        this.calcularCuota();
    }

    agregarDeduccion() {
        if (this.getMontoNetoPendientePago() < 0) {
            this.otrasDeduccion = '0';
            return 0;

        }
        this.calcularCuota();
    }

    changeTasaDetraccion(tasa) {
        this.tasaDetraccion = tasa;
        this.calcularCuota();
    }

    changeTasaRetencion(tasa) {
        this.tasaRetencion = tasa;
        this.calcularCuota();
    }

    changeMedioPago(medioPago) {
        this.medioPago = medioPago.description;
    }

    changeNroCuota(nro) {
        this.nroCuotas = nro;
        this.calcularCuota();
    }

    calcularCuota() {
        this.template_boleta.boleta.cuo = [];
        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            for (let i = 0; i < this.nroCuotas; i++) {
                this.template_boleta.boleta.cuo.push(
                    {
                        idCuota: 'Cuota00' + (i + 1),
                        montoPago: this.getMontoCuota(),
                        fechaPago: this.generarFechaPago((i + 1))
                    });
            }

            const aux = parseFloat(this.template_boleta.boleta.cuo[this.template_boleta.boleta.cuo.length - 1].montoPago) +
                (this.getMontoNetoPendientePago() -
                    (parseFloat(this.getMontoCuota()) * this.nroCuotas));

            this.template_boleta.boleta.cuo[this.template_boleta.boleta.cuo.length - 1].montoPago = aux.toFixed(2);
        }
    }

    montoPermitido() {
        const listEdit = this.template_boleta.boleta.cuo.filter((item) => (item.edit));
        let listNotEdit;
        let totalEdit = 0;
        let cuotaNotEdit = 0;
        if (listEdit.length > 0) {
            listEdit.forEach(item => totalEdit = totalEdit + parseFloat(item.montoPago));
        }
        // SE PASA El CAMPO MODIFICADO A EDITADO
        this.template_boleta.boleta.cuo[this.cuotaSelected].edit = true;

        // SE BUSCAN LOS QUE FALTAN POR SER MODIFICADOS
        listNotEdit = this.template_boleta.boleta.cuo.filter((item) => (!item.edit));

        if (listNotEdit.length === 0) {
            this.changeAmountPay = parseFloat((this.getMontoNetoPendientePago() - totalEdit).toString()).toFixed(2);
            return true;
        }

        if (parseFloat(this.changeAmountPay) >= this.getMontoNetoPendientePago()) {
            return false;
        }

        if (parseFloat(this.changeAmountPay) + totalEdit >= (this.getMontoNetoPendientePago() - listNotEdit.length)) {
            return false;
        }


        cuotaNotEdit = this.getMontoNetoPendientePago() - (parseFloat(this.changeAmountPay) + totalEdit);
        cuotaNotEdit = parseFloat((cuotaNotEdit / listNotEdit.length).toFixed(2));
        listNotEdit.forEach(item => item.montoPago = cuotaNotEdit);

        return true;
    }


    cambiar() {
        if (!this.montoPermitido()) {
            this.snackBar.open('El monto supera lo permitido', null, {duration: 2000});
            this.changeAmountPay = parseFloat((this.template_boleta.boleta.cuo[this.cuotaSelected].montoPago).toString()).toFixed(2);
            return false;
        }
        this.template_boleta.boleta.cuo[this.cuotaSelected].montoPago = parseFloat((this.changeAmountPay).toString()).toFixed(2);
        this.template_boleta.boleta.cuo[this.cuotaSelected].fechaPago =
            moment(this.changeDate).format('YYYY-MM-DD');
        this.cuotaSelected = null;
        this.changeAmountPay = null;
        this.changeDate = null;
    }

    cancelarChangeCuota() {
        this.cuotaSelected = null;
        this.changeAmountPay = null;
        this.changeDate = null;
    }

    seleccionarCuota(pos) {
        this.cuotaSelected = pos;
        this.changeAmountPay = this.template_boleta.boleta.cuo[pos].montoPago;
        this.changeDate = this.template_boleta.boleta.cuo[pos].fechaPago;
        if (pos === 0 && this.nroCuotas > 1) {
            this.minDate = moment().toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }
        if (pos === 0 && this.nroCuotas === 1) {
            this.minDate = moment().toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }

        if (pos !== 0 && pos < (this.template_boleta.boleta.cuo.length - 1)) {
            this.minDate = moment(
                this.template_boleta.boleta.cuo[pos - 1].fechaPago
            ).toDate();
            this.maxDate = moment(
                this.template_boleta.boleta.cuo[pos + 1].fechaPago
            ).toDate();
        }

        if (pos !== 0 && pos === (this.template_boleta.boleta.cuo.length - 1)) {
            this.minDate = moment(
                this.template_boleta.boleta.cuo[pos - 1].fechaPago
            ).toDate();
            this.maxDate = moment().add(1, 'years').toDate();
        }
    }


    generarFechaPago(mes) {
        let day: any = 7;
        switch (this.template_boleta.boleta.ide.formaPago) {
            case 'Credito':
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(mes, 'M').format('YYYY-MM-DD');
            case 'Crédito a 7 días':
                this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
            case 'Crédito a 15 días':
                day = 15;
                this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
            case 'Crédito a 30 días ':
                day = 30;
                this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
            case 'Crédito a 60 días':
                day = 60;
                this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
            case 'Crédito a 90 días':
                day = 90;
                this.template_boleta.boleta.ide.fechaVencimiento = moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
                return moment(this.template_boleta.boleta.ide.fechaEmision).add(day, 'days').format('YYYY-MM-DD');
        }
    }


    getMontoNetoPendientePago() {
        return parseFloat((this.totalCalculado() - this.totalCalculadoMontoDetraccion() -
            this.totalCalculadoMontoRetencion() - this.getOtrasDeduccion() - this.getMontoPagado()).toFixed(2));
    }

    generarADI() {
        this.template_boleta.boleta.adi = [];
        // FORMA DE PAGO
        this.template_boleta.boleta.adi.push(
            {
                tituloAdicional: 'Forma de Pago',
                valorAdicional: this.template_boleta.boleta.ide.formaPago
            });
        if (this.template_boleta.boleta.ide.formaPago !== 'Contado') {
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Monto Neto Pendiente de Pago',
                    valorAdicional: this.getMontoNetoPendientePago()
                });
        }
        this.template_boleta.boleta.cuo.forEach((cuota, pos) => {
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Cuota 00' + (pos + 1),
                    valorAdicional: this.template_boleta.boleta.ide.tipoMoneda +
                        ' ' + cuota.montoPago +
                        ' - ' + cuota.fechaPago
                });
        });

        // RETENCIÓN
        this.armarRetencionADI();
        // DETRACCION
        this.armarDetraccionADI();
        // ADDITIONAL
        this.armarAdditionalData();
    }

    armarRetencionADI() {

        if (this.getIdTypeOperation() === this.RETENCION) {
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '______________________________',
                    valorAdicional: '______________________________'
                });

            let valor = 'Base imponible de la Retención: ' + this.totalCalculadoMontoRetencion() +
                ' ' + this.getMontoNetoPendientePago() + '\n' +
                'Porcentaje de retención: ' + this.tasaRetencion + '%\n' +
                'Monto de la retención: ' + this.template_boleta.boleta.ide.tipoMoneda +
                ' ' + this.totalCalculadoMontoRetencion();

            if (this.template_boleta.boleta.ide.tipoMoneda !== 'PEN') {
                valor = valor + '\n' +
                    'Tipo de cambio: ' + this.tipoCambio;
            }

            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Información de la Retención',
                    valorAdicional: valor
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '______________________________',
                    valorAdicional: '______________________________'
                });
        }
    }

    armarDetraccionADI() {
        if (this.getIdTypeOperation() === this.DETRACCION) {
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '______________________________',
                    valorAdicional: '______________________________'
                });

            this.template_boleta.boleta.cab.leyenda = [];
            this.template_boleta.boleta.cab.leyenda.push({
                codigo: 2006,
                descripcion: 'Operación sujeta al Sistema de Pago de Obligaciones Tributarias.'
            });
            let valor = this.template_boleta.boleta.cab.leyenda[0].descripcion + '\n' +
                'Bien o Servicio sujeto a Detracción: \n' +
                this.servicioDetraccion + '\n' +
                'Depositar a la cuenta del Banco de la Nación \n' +
                'Nro. ' + this.nroCuenta + '\n' +
                'Medio de Pago:' + this.medioPago + '\n' +
                'Porcentaje de detracción: ' + this.tasaDetraccion + '%\n' +
                'Monto de la detracción: ' + this.template_boleta.boleta.ide.tipoMoneda +
                ' ' + this.totalCalculadoMontoDetraccion();

            if (this.template_boleta.boleta.ide.tipoMoneda !== 'PEN') {
                valor = valor + '\n' +
                    'Tipo de cambio: ' + this.tipoCambio;
            }

            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Detracciones',
                    valorAdicional: valor
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '______________________________',
                    valorAdicional: '______________________________'
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '@@codBienServDetr',
                    valorAdicional: this.servicioDetraccion.split(' - ')[0]
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '@@numCuentaBcoNacionDetr',
                    valorAdicional: this.nroCuenta
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '@@medioPagoDetr',
                    valorAdicional: this.medioPago.split(' - ')[0]
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '@@montoDetr',
                    valorAdicional: this.totalCalculadoMontoDetraccion()
                });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: '@@porcDetr',
                    valorAdicional: this.tasaDetraccion
                });
        }
    }

    changeTypeOperation(to) {
        this.template_boleta.boleta.cab.tipoOperacion = to.description;

        // calcular cuota si la boleta es a credito
        this.calcularCuota();

        // si la operacion es retencion o detraccion no lleva recargo al consumo
        if (this.getIdTypeOperation() === this.RETENCION ||
            this.getIdTypeOperation() === this.DETRACCION) {
            this.asignarRecargoConsumo('NO');
        }

        // Lista de inpuestos para un nuevo producto.
        this.impuestos = [];

        if (this.EXPORTACION_BIEN === this.getIdTypeOperation() || this.EXPORTACION_SERVICIO === this.getIdTypeOperation()) {
            this.impuestos.push('EXPORTADO');
            this.productoNuevo.affectationIGV = 'EXPORTADO';
            this.poseeDescuentoGlobalDiv = false;
            this.descuentoGlobal = 0;
            this.typeDocument = {value: this.DND, label: 'DND'};
            this.disabledTypeDocument = true;
        } else if (this.DETRACCION === this.getIdTypeOperation()) {

            this.impuestos.push('GRAVADO');
            this.productoNuevo.affectationIGV = 'GRAVADO';
            this.poseeDescuentoGlobalDiv = false;
            this.descuentoGlobal = 0;
            this.typeDocument = {value: this.DNI, label: 'DNI'};
            this.disabledTypeDocument = false;
        } else {
            this.impuestos.push('GRAVADO');
            this.impuestos.push('INAFECTO');
            this.impuestos.push('EXONERADO');
            this.productoNuevo.affectationIGV = 'GRAVADO';
            this.poseeDescuentoGlobalDiv = false;
            this.descuentoGlobal = 0;
            this.typeDocument = {value: this.DNI, label: 'DNI'};
            this.disabledTypeDocument = false;
        }

        // Limpiar los item seleccionados anteriormente
        this.removeAllDetails();
        // Limpiar receptor si cambia condicion
        // - EXPORTACION tipo de receptor DND
        // - RESTO  tipo de receptor RUC
        this.clearReceptor();
        this.filterReceptores();

        if (this.getIdTypeOperation() === this.DETRACCION) {
            this.servicioDetraccion = '022 - Otros servicios empresariales';
            this.medioPago = '001 - Deposito en cuenta';
        }
    }

    clearReceptor() {
        this.template_boleta.boleta.rec.numeroDocId = '';
        this.template_boleta.boleta.rec.razonSocial = null;
        this.template_boleta.boleta.rec.direccion = null;
        this.template_boleta.boleta.rec.telefono = null;
        this.template_boleta.boleta.rec.correoElectronico = null;
        $('.espacioCliente').animate({
            opacity: 0
        }, 500);
    }

    removeAllDetails() {
        // limpiar tabla de detalle
        for (let i = 0; i < this.template_boleta.boleta.det.length; i++) {
            this.items.removeAt(0);
        }
        this.template_boleta.boleta.det = [];
    }

    getIdTypeOperation() {
        let id = -99;
        if (this.template_boleta.boleta.cab.tipoOperacion) {
            this.operationType.forEach(item => {
                if (this.template_boleta.boleta.cab.tipoOperacion === item.description ||
                    this.template_boleta.boleta.cab.tipoOperacion === item.code) {
                    id = item.id;
                }
            });
        }
        return id;
    }

    getCodeTypeOperation() {
        let code = -99;
        if (this.template_boleta.boleta.cab.tipoOperacion) {
            this.operationType.forEach(item => {
                if (this.template_boleta.boleta.cab.tipoOperacion === item.description ||
                    this.template_boleta.boleta.cab.tipoOperacion === item.code) {
                    code = item.code;
                }
            });
        }
        return code;
    }

    setIdBienServicioTasa() {
        if (this.servicioDetraccion) {
            this.servicioDetraccionList.forEach(item => {
                if (this.servicioDetraccion === item.description || this.servicioDetraccion === item.code) {
                    this.tasaDetraccion = item.value;
                }
            });
        }
    }

    imposeMinMax($event: any, campo: string, pos: number) {
        let el = $event.target;
        if (el.value != "") {
            if (parseFloat(el.value) < parseFloat(el.min)) {
                el.value = el.min;
            }
            if (parseFloat(el.value) > parseFloat(el.max)) {
                el.value = el.max;
            }
            return false;
        } else {
            el.value = '0.00';
            if (campo === 'DESCUENTO_GLOBAL') {
                this.descuentoGlobal = 0;
            }
            if (campo === 'DESCUENTO_ITEM') {
                this.template_boleta.boleta.det[pos].descuento = 0;
            }
            this.cd.markForCheck();
            this.cd.detectChanges();
        }
    }


    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim()) {
            this.guiaRemision.push(value.trim().toUpperCase());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(guia: any): void {
        const index = this.guiaRemision.indexOf(guia);

        if (index >= 0) {
            this.guiaRemision.splice(index, 1);
        }
    }

    addTransporte(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim()) {
            this.guiaRemisionTransporte.push(value.trim().toUpperCase());
        }

        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    removeTransporte(guia: any): void {
        const index = this.guiaRemisionTransporte.indexOf(guia);

        if (index >= 0) {
            this.guiaRemisionTransporte.splice(index, 1);
        }
    }


    getAdditionalDataPermanent() {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            }
        });
        this.consumerService.post(WebServices.URL_GET_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            let list = result['additionalDataPermanents'];
            list.forEach((item) => {
                    if (item.documentType == 'TICKET') {
                        this.additionalDataPermanent.push({
                            id: item.id,
                            tituloAdicional: item.tituloAdicional,
                            valorAdicional: item.valorAdicional
                        });
                    }

                }
            );
        }, err => {
            console.log('ERROR' + err);
            swal({
                title: 'Error',
                text: UtilConfig.DEFAULT_MESSAGE_ERROR,
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Proceder!'
            });
        });
    }

    armarAdditionalData() {

        if (this.notesOnTheReceipt != null && this.notesOnTheReceipt != '') {
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Observaciones',
                    valorAdicional: this.notesOnTheReceipt
                });
        }

        if (this.guiaRemision != null && this.guiaRemision.length > 0) {
            this.template_boleta.boleta.drf = [];
            let guiaRemisionString = '';
            this.guiaRemision.forEach(item => {
                guiaRemisionString += item + '\n';
                const guia = new Drf('09', item);
                this.template_boleta.boleta.drf.push(guia);
            });
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Guias de Remisión Remitente',
                    valorAdicional: guiaRemisionString
                });
        }

        if (this.guiaRemisionTransporte != null && this.guiaRemisionTransporte.length > 0) {
            let guiaRemisionTransporteString = '';
            this.guiaRemisionTransporte.forEach(item => {
                guiaRemisionTransporteString += item + '\n';
            })
            this.template_boleta.boleta.adi.push(
                {
                    tituloAdicional: 'Guias de Remisión Transportista',
                    valorAdicional: guiaRemisionTransporteString
                });
        }

        if (this.additionalDataPermanent != null && this.additionalDataPermanent.length > 0) {
            this.additionalDataPermanent.forEach(item => {
                this.template_boleta.boleta.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }

        if (this.additionalDataTmp != null && this.additionalDataTmp.length > 0) {
            this.additionalDataTmp.forEach(item => {
                this.template_boleta.boleta.adi.push(
                    {
                        tituloAdicional: item.tituloAdicional,
                        valorAdicional: item.valorAdicional
                    });
            });
        }
    }

    removeAditionalDataPermanent(pos, item) {
        const body = JSON.stringify({
            additionalDataPermanent: item
        });
        this.removeAdditionalPermanent = true;
        this.consumerService.post<any>(WebServices.URL_DELETE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            this.additionalDataPermanent.splice(pos, 1);
            this.removeAdditionalPermanent = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.removeAdditionalPermanent = false;
            console.log('ERROR' + err);
        });
    }

    removeAditionalDataTmp(pos) {
        this.additionalDataTmp.splice(pos, 1);
    }

    addAdditionalDataTmp() {
        if (this.keyTemp == '' || this.valueTemp == '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        this.additionalDataTmp.push({
            tituloAdicional: this.keyTemp,
            valorAdicional: this.valueTemp
        });
        this.keyTemp = '';
        this.valueTemp = '';
    }

    addAdditionalDataPermanent() {
        if (this.keyPermanent == '' || this.valuePermanent == '') {
            this.snackBar.open('Debe completar los campos', null, {duration: 2000});
            return false;
        }

        const body = JSON.stringify({
            additionalDataPermanent: {
                id: this.util.getCurrentUser().customer.id,
                documentType: 'TICKET',
                tituloAdicional: this.keyPermanent,
                valorAdicional: this.valuePermanent,
                logUsernameRegistro: this.util.getCurrentUser().username
            },
            customer: {
                id: this.util.getCurrentUser().customer.id,
                ruc: this.util.getCurrentUser().customer.ruc,
            }
        });
        this.loadingAddDataAditional = true;
        this.consumerService.post<any>(WebServices.URL_SAVE_ADDITIONAL_DATA_PERMANENT, body).subscribe(result => {
            let additionalDataPermanent = result['additionalDataPermanent'];
            this.loadingAddDataAditional = false;
            this.additionalDataPermanent.push({
                tituloAdicional: additionalDataPermanent.tituloAdicional,
                valorAdicional: additionalDataPermanent.valorAdicional
            });
        }, err => {
            this.loadingAddDataAditional = false;
            console.log('ERROR' + err);
        });

        this.keyPermanent = '';
        this.valuePermanent = '';

    }

    scroll(id: string) {
        let el = document.getElementById(id);
        el.scrollIntoView();
    }


    getIdByName(name) {
        const body = JSON.stringify({
            customer: {
                ruc: this.util.getCurrentUser().customer.ruc,
                id: this.util.getCurrentUser().customer.id
            },
            filename: name,
            documentType: 'TICKET'
        });
        this.cargaDocumentos = true;
        this.consumerService.update(WebServices.URL_GET_ID_DOCUMENT, body).subscribe(result => {
            this.cargaDocumentos = false;
            this.logSeleccionado.id = result['idDocument'];
            this.logSeleccionado.linkRequestPSE = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PSE&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkRequestXML = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=XML&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkResponseCDR = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=CDR&authorization=' + this.util.getJwtToken();
            this.logSeleccionado.linkResponsePDF = this.util.URL_WS_BACKEND + WebServices.URL_GET_ARCHIVO_LOG_EMISOR + '?log.id=' + this.logSeleccionado.id + '&tipoDescarga=PDF&authorization=' + this.util.getJwtToken();

            this.cd.markForCheck();
            this.cd.detectChanges();
        }, err => {
            this.cargaDocumentos = false;
            this.cd.markForCheck();
            this.cd.detectChanges();
            this.util.abrirModalErrorParaServicios(err, 'Error', this.router);
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/boleta/boleta.component.ts